import { useEffect } from 'react';
import {
  Button,
  Input,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { useForm, useController } from 'react-hook-form';
import type { Props } from './types';
import messages from '../messages';
import { MAX_DECLINE_REASON_LENGTH, normalizeDeclineReason } from './utils';

function DeclineWithoutCriminalScreeningModal({
  intl,
  open,
  isSubmitting,
  onClose,
  onConfirm,
}: Props) {
  const { control, handleSubmit, formState, reset } = useForm({
    mode: 'all',
  });
  const { field: reasonField } = useController({
    control,
    name: 'reason',
    defaultValue: '',
    rules: {
      validate: (v) => normalizeDeclineReason(v) != null,
    },
  });
  const onSubmitWrapper = handleSubmit(({ reason }) =>
    onConfirm(normalizeDeclineReason(reason)),
  );

  useEffect(() => {
    reset();
  }, [open, reset]);

  return (
    <form>
      <Modal
        open={open}
        onClose={onClose}
        title={intl.formatMessage(messages.stopScreeningTitle)}
        actions={
          <>
            <Button variant="text" onClick={onClose}>
              {intl.formatMessage(messages.cancel)}
            </Button>
            <Button
              variant="primary"
              onClick={onSubmitWrapper}
              disabled={isSubmitting || !formState.isValid}
            >
              {intl.formatMessage(messages.confirmDecline)}
            </Button>
          </>
        }
        ModalProps={{
          PaperProps: {
            sx: {
              width: {
                xs: 'calc(100% - 32px)',
                sm: 480,
              },
            },
          },
        }}
      >
        <Stack spacing={2}>
          <Typography variant="bodyMedium">
            {intl.formatMessage(messages.stopScreeningBody)}
          </Typography>
          <Stack>
            <Typography id="reason_label" variant="labelLarge">
              {intl.formatMessage(messages.reasonForDecline)} *
            </Typography>
            <Input
              {...reasonField}
              required
              multiline
              minRows={3}
              placeholder={intl.formatMessage(
                messages.reasonForDeclinePlaceholder,
              )}
              helperText={intl.formatMessage(messages.reasonForDeclineHelp)}
              inputProps={{ maxLength: MAX_DECLINE_REASON_LENGTH }}
            />
          </Stack>
        </Stack>
      </Modal>
    </form>
  );
}

export default DeclineWithoutCriminalScreeningModal;
